import { useState } from "react";
import PropTypes from "prop-types";
import { getCurrentUser } from "../../../action/user";
import { connect } from "react-redux";

const UserSearchInputWrapper = ({
  onSubmit: onSubmitProp = () => {},
  resetTextOnSubmit = true,
  onSearchByChange: onSearchByChangeProp = () => {},
  onSearchValueChange: onSearchValueChangeProp = () => {},
  onSubmitSuccess = () => {},
  onSubmitFailure = () => {},
  getCurrentUser,
  tenantInfo,
  allowedCountries,
  showText,
  children,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState("mobile");
  const [countryCode, setCountryCode] = useState("91");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (countryCode || searchBy === "email") {
      let searchText = searchValue;
      if (searchBy === "mobile" && countryCode) {
        searchText = `+${countryCode}${searchValue}`;
      }

      try {
        const res = await getCurrentUser(
          searchText,
          searchBy,
          tenantInfo?.tenantId,
        );
        onSubmitSuccess(e, res);
      } catch (err) {
        onSubmitFailure(e, err);
      }

      onSubmitProp(e);

      if (resetTextOnSubmit) {
        setSearchValue("");
      }
    }
  };

  const handleSearchByChange = (e) => {
    setSearchBy(e.target.value);
    setSearchValue("");
    onSearchByChangeProp(e);
  };

  const handleSearchValueChange = (e) => {
    setSearchValue(e.target.value);
    onSearchValueChangeProp(e);
  };

  return (
    <>
      {children({
        searchValue,
        searchBy,
        countryCode,
        onSubmit: handleSubmit,
        setCountryCode,
        onSearchByChange: handleSearchByChange,
        onSearchValueChange: handleSearchValueChange,
        showText: showText,
        allowedCountries: allowedCountries,
      })}
    </>
  );
};

UserSearchInputWrapper.propTypes = {
  onSubmit: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  onSubmitFailure: PropTypes.func,
  children: PropTypes.func.isRequired,
  resetTextOnSubmit: PropTypes.bool,
  onSearchByChange: PropTypes.func,
  onSearchValueChange: PropTypes.func,
};

export default connect(
  (state) => ({
    user: state.user,
    tenantInfo: state.tenant.tenantInfo,
    allowedCountries: state.auth.allowedCountries,
  }),
  (dispatch) => ({ getCurrentUser: getCurrentUser(dispatch) }),
)(UserSearchInputWrapper);
